import Vue from "vue";
import Vuex from "vuex";
const fb = require("../firebase.js");

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    cup: {},
    routeParams: {},
    customer: {},
    customerReady: false,
    reward: { overlay: false, src: "", value: null, name: "" },
    snackbar: { active: false, color: "", mode: "", timeout: -1, text: "" },
    dialogLocations: false,
    dialogPrizes: false,
    dialogContact: false,
    lightMode: true,
    shadow: true,
    slotMachineIsRunning: false,
    loading: false,
    selfies: [],
    selfiesLoaded: false,
    reelSourceData: [
      {
        name: "Lemon",
        value: 2,
        slotMachineRewardUrl: "/img/10.png",
      },
      {
        name: "Melon",
        value: 4,
        slotMachineRewardUrl: "/img/11.png",
      },
      {
        name: "Beer",
        value: 0,
        slotMachineRewardUrl: "/img/beer.png",
      },
      {
        name: "Cherry",
        value: 16,
        slotMachineRewardUrl: "/img/13.png",
      },
      {
        name: "Bar",
        value: 72,
        slotMachineRewardUrl: "/img/casino.png",
      },
    ],
  },
  mutations: {
    setReelSourceData(state, val) {
      state.reelSourceData.splice(2, 1, {
        name: "Beer",
        value: 0,
        slotMachineRewardUrl: val,
      });
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setRouteParams(state, val) {
      state.routeParams = val || {};
    },
    setSelfiesLoaded(state, val) {
      state.selfiesLoaded = val;
    },
    setUser(state, val) {
      state.user = val;
    },
    setCup(state, val) {
      state.cup = val;
    },
    setCustomer(state, val) {
      state.customer = val;
    },
    setCustomerReady(state, val) {
      state.customerReady = val;
    },
    setSnackbar(state, val) {
      state.snackbar = Object.assign({}, val, { active: true });
    },
    setSlotMachineIsRunning(state, val) {
      state.slotMachineIsRunning = val;
    },
    setReward(state, val) {
      state.reward = val;
    },
    setDialogPrizes(state, val) {
      state.dialogPrizes = val;
    },
    setDialogLocations(state, val) {
      state.dialogLocations = val;
    },
    setDialogContact(state, val) {
      state.dialogContact = val;
    },
    setLightMode(state, val) {
      state.lightMode = val;
    },
    setShadow(state, val) {
      state.shadow = val;
    },
    setPushItem(state, val) {
      state.selfies.push(Object.assign({ uid: val.id }, val.item));
    },
    setUnshiftItem(state, val) {
      state.selfies.unshift(Object.assign({ uid: val.id }, val.item));
    },
    setDeleteItem(state, val) {
      state.selfies = state.selfies.filter(function(item) {
        return item.uid != val.id;
      });
    },
    setUpdateItem(state, val) {
      state.selfies = state.selfies.map((item) =>
        item.uid == val.id ? Object.assign({ uid: val.id }, val.item) : item
      );
    },
  },
  actions: {
    updateUserCredits({ commit, state, dispatch }, payload) {
      fb.db
        .collection("users")
        .doc(fb.firebase.auth().currentUser.uid)
        .update({ credits: state.user.credits + payload })
        .catch((err) => {
          console.log(err);
        });
    },
    sendEmail({ commit, state, dispatch }, payload) {
      fb.db
        .collection("users")
        .doc(fb.firebase.auth().currentUser.uid)
        .update({ emailSent: true, email: payload.email })
        .catch((err) => {
          console.log(err);
        });
      fb.db
        .collection("contacts")
        .add({
          email: payload.email,
          text: payload.text,
        })
        .then((res) => {})
        .catch((err) => {
          console.log(err);
          self.$store.commit("setSnackbar", {
            color: "error",
            timeout: 3000,
            text: "Error 🤯",
          });
          self.loading = false;
        });
    },
    updateUserButtonNotClickedYet({ commit, state, dispatch }) {
      fb.db
        .collection("users")
        .doc(fb.firebase.auth().currentUser.uid)
        .update({ buttonNotClickedYet: false })
        .catch((err) => {
          console.log(err);
        });
    },
    async createAnonymousUser({ commit, state, dispatch }) {
      console.log("createAnonymousUser");
      commit("setUser", { new: true });
      try {
        const cred = await fb.auth.signInAnonymously();
        if (cred) {
          fb.db
            .collection("users")
            .doc(cred.user.uid)
            .set({
              credits: 3,
              emailSent: false,
              buttonNotClickedYet: true,
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (error) {
        console.log(error);
      }
    },
    getUser({ commit, state }) {
      console.log("getUser");
      fb.db
        .collection("users")
        .doc(fb.firebase.auth().currentUser.uid)
        .onSnapshot((doc) => {
          commit(
            "setUser",
            Object.assign(
              {
                id: fb.firebase.auth().currentUser.uid,
              },
              doc.data()
            )
          );
        });
    },
    getCup({ commit, state }, id) {
      console.log("getCup");
      fb.db
        .collection("cups")
        .doc(id)
        .onSnapshot((doc) => {
          commit(
            "setCup",
            Object.assign(
              {
                id: id,
              },
              doc.data()
            )
          );
        });
      fb.db
        .collection("cups/" + id + "/customers")
        .limit(6)
        .onSnapshot(
          (snapshot) => {
            snapshot.docChanges().forEach(function(change) {
              if (change.type === "added") {
                commit(
                  "setCustomer",
                  Object.assign(
                    {
                      id: change.doc.id,
                    },
                    change.doc.data()
                  )
                );
              }
              if (change.type === "modified") {
                console.log("modified");
              }
              if (change.type === "removed") {
                console.log("removed");
              }
            });
          },
          (error) => {
            console.log(error);
          }
        );
    },

    // getCustomer({ commit, state }, customer) {
    //   console.log("getCustomer");
    //   fb.db
    //     .collection("customers")
    //     .doc(customer)
    //     .onSnapshot((doc) => {
    //       commit("setReelSourceData", doc.data().slotMachineRewardUrl);
    //       commit(
    //         "setCustomer",
    //         Object.assign(
    //           {
    //             id: customer,
    //           },
    //           doc.data()
    //         )
    //       );
    //       commit("setCustomerReady", true);
    //     });
    // },
    getSelfies({ state, commit, dispatch }, payload) {
      console.log("getSelfies");
      fb.firebase
        .firestore()
        .collection(
          "customers/" + payload.customer + "/cups/" + payload.cup + "/selfies"
        )
        .orderBy("date", "desc")
        .limit(6)
        .onSnapshot(
          (snapshot) => {
            commit("setSelfiesLoaded", true);

            snapshot.docChanges().forEach(function(change) {
              if (change.type === "added") {
                if (!change.doc.data().imageUrl) {
                  commit("setUnshiftItem", {
                    item: Object.assign({}, change.doc.data(), {
                      // imageUrl: state.image.dataUrl,
                    }),
                    id: change.doc.id,
                    // imageUrl: state.image.dataUrl,
                  });
                } else {
                  commit("setPushItem", {
                    item: change.doc.data(),
                    id: change.doc.id,
                  });
                }
              }
              if (change.type === "modified") {
                // console.log("modified");
                commit("setUpdateItem", {
                  item: change.doc.data(),
                  id: change.doc.id,
                });
              }
              if (change.type === "removed") {
                // console.log("removed");
                commit("setDeleteItem", {
                  item: change.doc.data(),
                  id: change.doc.id,
                });
              }
            });
          },
          (error) => {
            console.log(error);
          }
        );
    },

    createItem({ state, commit, dispatch }, payload) {
      commit("setLoading", true);
      // if (!payload.event.target.files[0]) return commit("setLoading", false);

      let item = {
        date: Date.now(),
        userUid: fb.firebase.auth().currentUser.uid,
      };
      fb.firebase
        .firestore()
        .collection(
          "customers/" +
            payload.params.customer +
            "/cups/" +
            payload.params.cup +
            "/selfies"
        )
        .add(item)
        .then(function(doc) {
          commit("setLoading", false);
          dispatch("uploadItem", {
            uid: doc.id,
            params: payload.params,
            image: payload.image,
          });
        })
        .catch(function(error) {
          console.log(error);
          commit("setSnackbar", {
            color: "error",
            timeout: 3000,
            text: "Error",
          });
          commit("setLoading", false);
        });
    },
    uploadItem({ state, commit, dispatch }, payload) {
      // File or Blob named mountains.jpg
      // var file = state.image;
      var file = payload.image;

      // Create the file metadata
      var metadata = {
        contentType: file.type,
      };
      var imageName =
        payload.params.customer +
        "_" +
        payload.params.cup +
        "_" +
        payload.uid +
        "_" +
        Date.now();
      var uploadTask = fb.firebase
        .storage()
        .ref("/selfies")
        .child(imageName)
        .putString(file, "data_url");

      uploadTask.on(
        "state_changed",
        function(snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case fb.firebase.storage.TaskState.PAUSED: // or 'paused'
              // console.log("Upload is paused");
              break;
            case fb.firebase.storage.TaskState.RUNNING: // or 'running'
              // console.log("Upload is running");
              break;
          }
        },
        function(error) {
          // Handle unsuccessful uploads
        },
        function() {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            let updatedItem = {
              item: {
                uid: payload.uid,
                imageUrl: downloadURL,
                imageName: imageName,
              },
              params: payload.params,
            };
            dispatch("updateItem", updatedItem);
          });
        }
      );
    },
    updateItem({ state, commit }, payload) {
      commit("setLoading", true);
      fb.firebase
        .firestore()
        .collection(
          "customers/" +
            payload.params.customer +
            "/cups/" +
            payload.params.cup +
            "/selfies"
        )
        .doc(payload.item.uid)
        .update(payload.item)
        .then(function() {
          commit("setLoading", false);
          commit("setSnackbar", {
            color: "primary",
            timeout: 3000,
            text: "Selfie saved",
          });
        })
        .catch((err) => {
          commit("setLoading", false);
          console.log(err);
        });
    },
    deleteItem({ state, commit, dispatch }, payload) {
      if (payload.selfie.imageName) {
        fb.firebase
          .storage()
          .ref("/selfies")
          .child(payload.selfie.imageName)
          .delete()
          .then(function() {})
          .catch(function(error) {
            // Uh-oh, an error occurred!
            commit("setSnackbar", {
              color: "error",
              timeout: 3000,
              text: error,
            });
          });
      }

      fb.db
        .collection(
          "customers/" + payload.customer + "/cups/" + payload.cup + "/selfies"
        )
        .doc(payload.selfie.uid)
        .delete()
        .then(function() {
          commit("setSnackbar", {
            color: "primary",
            timeout: 3000,
            text: "Seflie deleted",
          });

          // commit("setLoading", false)
        })
        .catch(function(error) {
          console.log(error);
          // commit("setLoading", false)
        });
    },
  },
  modules: {},
});
